import { useState } from 'react';
import { Button } from '@flixbus/honeycomb-react';
import { Icon, IconDownload } from '@flixbus/honeycomb-icons-react';

import { useBatch } from '../../context/VoucherBatchProvider';
import { getBatchDownloadData } from '../../apis';
import { useNotification } from '../Notifications/Context';

const DownloadBatch = () => {
  const [pending, setPending] = useState(false);
  const [downloaded, setDownloaded] = useState(false);
  const { pushToast } = useNotification();
  const { data } = useBatch();
  const createComplete = data.remainingSize === 0;
  const WARNING_SIZE = 100000;

  const downloadFile = (response: string) => {
    const url = window.URL.createObjectURL(new Blob([response], { type: 'text/csv' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${data.id}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const getVoucherDownloadUrl = async () => {
    setPending(true);
    pushToast({
      message: 'Downloading batch, please wait...',
      status: 'success',
    });

    if (data.batchSize > WARNING_SIZE) {
      pushToast({
        message: 'Closing the tab will cancel the download. Please wait until it finishes.',
        status: 'warning',
      });
    }

    try {
      const response = await getBatchDownloadData(data.id);
      downloadFile(response);
      setDownloaded(true);
      pushToast({
        message: 'Batch downloaded successfully!',
        status: 'success',
      });
    } catch (error) {
      pushToast({
        message: `Error downloading batch: ${error instanceof Error ? error.message : 'Unknown error'}`,
        status: 'danger',
      });
    } finally {
      setPending(false);
    }
  };

  return (
    <div>
      <Button
        appearance='link'
        disabled={!createComplete || downloaded || pending}
        onClick={getVoucherDownloadUrl}
        loading={pending}
      >
        <Icon InlineIcon={IconDownload} />
        {downloaded ? 'Downloaded!' : 'Download Batch'}
      </Button>
    </div>
  );
};

export default DownloadBatch;
